import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './styles.scss';
import AdminRoute from '../AdminRoute';
import AdminTable from '../AdminTable';
import ConfirmDialog from '../ConfirmDialog';
import OwnerForm from './OwnerForm';
import UpdateSessionMutation from '../../mutations/UpdateSession';
import HeightDownAnimation from '../HeightDownAnimation';

class AdminOwners extends Component {
	constructor(props) {
		super(props);
		this.removeOwner = this.removeOwner.bind(this);

		this.state = {
			showDialog: false,
			recordIdToRemove: null,
			showForm: false,
			owners: {
				columnsBackground: '#ffe9da',
				columns: [
					{
						label: 'ID',
						key: 'id',
						styles: {
							display: 'none'
						},
						rowColumnStyles: {
							display: 'none'
						}
					},
					{
						label: 'name',
						key: 'name',
						styles: {
							width: '30%'
						},
						rowColumnStyles: {
							width: '30%',
							color: '#3a3a40'
						}
					},
					{
						label: 'creator',
						key: 'creator',
						styles: {
							width: '30%',
							display: 'flex',
							justifyContent: 'center'
						},
						rowColumnStyles: {
							width: '30%',
							display: 'flex',
							justifyContent: 'center'
						}
					},
					{
						label: 'roles',
						key: 'roles',
						styles: {
							width: '30%'
						},
						rowColumnStyles: {
							width: '30%',
							color: '#3a3a40'
						}
					},
					{
						label: '',
						key: 'actions',
						styles: {
							width: '10%',
							display: 'flex',
							justifyContent: 'space-between',
							margin: '0 30px 0 auto'
						},
						rowColumnStyles: {
							width: '10%',
							display: 'flex',
							justifyContent: 'space-between',
							margin: '0 30px 0 auto'
						}
					}
				],
				// Actions for each row
				actions: [
					{
						key: 'remove',
						icon: 'trash',
						tooltip: 'Remove',
						to: null,
						clicked: this.removeOwner,
						param: 'id',
						disabled: () => {
							return this.state.owners.rows.length > 1 ? false : true;
						}
					}
				],
				rows: []
			},
			form: {
				edit: false,
				selects: [
					{
						type: 'select',
						name: 'owner',
						value: '',
						options: [],
						selected: false,
						disabled: false,
						placeholder: 'Select owner'
					}
				],
				cta: 'Add Owner',
				height: '150px'
			}
		};

		this.onClickAdd = this.onClickAdd.bind(this);
		this.toggleFormVisibility = this.toggleFormVisibility.bind(this);
		this.onChangeFormValue = this.onChangeFormValue.bind(this);
		this.setFormValue = this.setFormValue.bind(this);
		this.createJsonObject = this.createJsonObject.bind(this);
		this.resetFields = this.resetFields.bind(this);
		this.onClose = this.onClose.bind(this);
		this.onModalClose = this.onModalClose.bind(this);
		this.onClickShowField = this.onClickShowField.bind(this);
		this.toggleDialog = this.toggleDialog.bind(this);
		this.onClickConfirm = this.onClickConfirm.bind(this);
		this.onOwnerSelected = this.onOwnerSelected.bind(this);
		this.onOwnerValueChanged = this.onOwnerValueChanged.bind(this);
		this.setOwners = this.setOwners.bind(this);
		this.setAvailableOwners = this.setAvailableOwners.bind(this);
		this.onOwnerSelectClicked = this.onOwnerSelectClicked.bind(this);
		this.onOwnerSelectItemClicked = this.onOwnerSelectItemClicked.bind(this);
	}

	componentDidMount() {
		this.setOwners(this.props);
		this.setAvailableOwners(this.props);
	}

	componentWillReceiveProps(nextProps) {
		this.setOwners(nextProps);
		this.setAvailableOwners(nextProps);
	}
	onOwnerSelectClicked() {
		const form = { ...this.state.form };
		form.selects[0].showList = !form.selects[0].showList;
		this.setState({
			form
		});
	}
	onOwnerSelectItemClicked(ev) {
		const form = { ...this.state.form };
		const value = ev.target.getAttribute('data-value');
		form.selects[0].showList = false;
		form.selects[0].value = value;
		this.setState({
			form
		});
	}

	setOwners(props) {
		const data = props.owners;
		let owners = { ...this.state.owners };
		owners.rows = data;
		this.setState({
			owners
		});
	}

	setAvailableOwners(props) {
		let form = { ...this.state.form };
		const availableOwners = props.availableOwners
			? props.availableOwners.map(user => ({
				value: user.id,
				description: `${user.firstName} ${user.lastName}`
			  }))
			: [];
		form.selects[0].options = availableOwners;
		this.setState({
			form
		});
	}

	onClickAdd() {
		this.toggleFormVisibility();
	}

	toggleFormVisibility(status) {
		const showForm = status ? status : !this.state.showForm;
		this.setState(
			{
				showForm
			},
			() => {
				if (!showForm) this.resetFields();
			}
		);
	}

	resetFields() {
		const form = { ...this.state.form };
		form.selects.forEach(item => {
			item.value = '';
			item.selected = false;
		});
		setTimeout(() => {
			this.setState({
				form
			});
		}, 800);
	}

	setFormValue(key = 'inputs', field, value, ignoreToggle = false) {
		const form = { ...this.state.form };
		form[key].forEach(item => {
			const valueToSet = item.name === field ? value : item.value;

			if (item.hasOwnProperty('asArray') && item.asArray) {
				const curIx = item.values.indexOf(valueToSet);
				if (curIx > -1) {
					if (!ignoreToggle) {
						item.values.splice(curIx, 1);
					}
				} else {
					item.values.push(valueToSet);
				}
			} else {
				item.value = valueToSet;
			}
		});
		this.setState({
			form
		});
	}

	onChangeFormValue(ev) {
		ev.preventDefault();
		const inputName = ev.target.name;
		const value = ev.target.value;
		this.setFormValue('inputs', inputName, value);
	}

	createJsonObject(updateSession) {
		const { session } = this.props;
		let form = { ...this.state.form };
		const value = form.selects[0].value;
		const owners = [...session.owners.map(o => o.id), value];
		updateSession({
			variables: {
				sessionID: session.id,
				data: {
					owners
				}
			}
		});
		this.toggleFormVisibility();
	}

	onClickShowField(ev) {
		const row = ev.target.getAttribute('data-row');
		const column = ev.target.getAttribute('data-column');
		const key = ev.target.getAttribute('data-field');
		let owners = { ...this.state.owners };
		owners.columns.forEach(columnItem => {
			if (columnItem.key === key) {
				if (
					columnItem.rowIndexToUnlock === row &&
					columnItem.columnIndexToUnlock === column
				) {
					columnItem.rowIndexToUnlock = -1;
					columnItem.columnIndexToUnlock = -1;
				} else {
					columnItem.rowIndexToUnlock = row;
					columnItem.columnIndexToUnlock = column;
				}
			}
		});

		this.setState({
			owners
		});
	}

	onClose(ev) {
		ev.preventDefault();
		this.toggleFormVisibility();
	}

	onModalClose(ev) {
		ev.preventDefault();
		this.toggleModalVisibility();
	}

	removeOwner(ev) {
		const recordIdToRemove = ev.target.getAttribute('data-id');
		this.setState(
			{
				recordIdToRemove
			},
			() => {
				this.toggleDialog();
			}
		);
	}

	onOwnerValueChanged(value, name) {
		const form = { ...this.state.form };
		form.selects.forEach(select => {
			if (select.name === name) {
				select.value = value;
				select.selected = false;
			}
		});
		this.setState({
			form
		});
	}

	onOwnerSelected(suggestion, name) {
		const form = { ...this.state.form };
		const { value } = suggestion;
		form.selects.forEach(select => {
			if (select.name === name) {
				select.value = value;
				select.selected = true;
			}
		});
		this.setState({
			form
		});
	}

	toggleDialog() {
		let showDialog = !this.state.showDialog;
		this.setState({
			showDialog
		});
	}

	onClickConfirm(updateSession) {
		const id = this.state.recordIdToRemove;
		const { session } = this.props;
		let owners = [...session.owners.map(o => o.id)];
		const index = owners.indexOf(id);
		if (index !== -1) {
			owners.splice(index, 1);
		} else {
			console.log('cant find id in owners list');
		}
		updateSession({
			variables: {
				sessionID: session.id,
				data: {
					owners
				}
			}
		});
		this.setState(
			{
				recordIdToRemove: null
			},
			() => {
				this.toggleDialog();
			}
		);
	}

	render() {
		const { owners, showForm, form, showDialog, recordIdToRemove } = this.state;
		return (
			<UpdateSessionMutation>
				{updateSession => (
					<div className="AdminOwners">
						{showDialog && (
							<ConfirmDialog
								id={recordIdToRemove}
								title={'Deleting owner'}
								description={
									'Are you sure you want to delete this owner?<br />Once deleted it cannot be recovered.<br />Pay attention! If you delete the last owner remaining<br />the whole session will be deleted!'
								}
								icon={'trash'}
								show={showDialog}
								confirmClicked={() => this.onClickConfirm(updateSession)}
								closeDialogClicked={this.toggleDialog}
							/>
						)}
						<AdminRoute
							title="Owners"
							subTitle="Owners"
							icon="usersColor"
							buttonCta="Add owner"
							buttonClicked={() => this.onClickAdd()}
							form={
								<HeightDownAnimation show={showForm} height={210}>
									<OwnerForm
										changed={this.onChangeFormValue}
										submitted={() => this.createJsonObject(updateSession)}
										selectClicked={this.onOwnerSelectClicked}
										selectItemClicked={this.onOwnerSelectItemClicked}
										closed={this.onClose}
										form={form}
									/>
								</HeightDownAnimation>
							}
						>
							<AdminTable
								table={owners}
								emptyMessage={'No owners found'}
								numberOfRows={owners.rows.length}
								limit={8}
								hasPagination={false}
								showField={this.onClickShowField}
							/>
						</AdminRoute>
					</div>
				)}
			</UpdateSessionMutation>
		);
	}
}

AdminOwners.propTypes = {
	owners: PropTypes.arrayOf(PropTypes.object)
};

export default AdminOwners;
